import { Loader2 } from "lucide-react";

export function Loader({ label = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-3 text-[#434654]" data-testid="loader">
      <Loader2 className="w-6 h-6 animate-spin text-[#003d9b]" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
